// src/pages/History/RenaissanceReformation/ScientificRevolutionGo.jsx
import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Renaissance_&_Reformation_-_Scientific_Revolution.png';

export default function HistoryPageScientificRevolutionGo() {
  return (
    <QuizPage
      title="History: Scientific Revolution"
      subTopic="Scientific Revolution"
      backgroundImage={historyImage}
      returnPath="/History-Scientific-Revolution"
    />
  );
}
